import { Component, Input, OnInit } from '@angular/core';
import { LeaveType } from '@core/models/enums';

@Component({
  selector: 'caremoni-leave',
  templateUrl: './leave.component.html',
  styleUrl: './leave.component.scss',
})
export class LeaveComponent implements OnInit {
  @Input() data: any;
  isLeave: boolean = false;
  blinking: boolean = false;
  blinkColor: 'red' | 'yellow' = 'red';

  ngOnInit(): void {
    switch (this.data.value) {
      case LeaveType.leave:
        this.isLeave = true;
        break;
      case LeaveType.Wait:
        // this.blinking = true;
        // this.blinkColor = 'yellow';
        break;
      case LeaveType.Cancel:
        this.isLeave = true;
        break;
      case LeaveType.Wipe:
        this.isLeave = true;
        break;
      default:
        break;
    }

  }

  get blinkClass(): string {
    return this.blinking ? `blink-${this.blinkColor}` : '';
  }
}
